import React, { Component } from "react";
import { connect } from "react-redux";
import "./RoomTitleSettings.scss";
import SettingsWrapper from "../../../components/Settings/SettingsWrapper";
import translator from "../../../utils/translator";
import Axios from "axios-https-proxy-fix";
import Button from "@material-ui/core/Button";

export class RoomTitleSettings extends Component {
	resetState = () => {
		return {
			allWarehouses: [],
			warehouse: null,
			roomsLoaded: 0,
			response: {},
			roomTitles: [],
			newRoomTitle: "",
		};
	};

	state = this.resetState();

	nestedUpdate = (state, ...keys) => {
		// UPDATES THE STATE so that nestedUpdate(state, k1, k2, k3, val) updates state.k1.k2.k3 = val
		let value = keys.pop();
		let objs = keys.reduce(
			(objs, key) => {
				objs.push(objs[objs.length - 1][key]);
				return objs;
			},
			[state]
		);
		objs.pop();
		let newState = objs.reduceRight((newState, obj, index) => {
			let next = {
				...obj,
				[keys[index]]: newState
			};
			return next;
		}, value);
		this.setState(state => newState);
	};

	nestedToggle = (state, ...keys) => {
		let val = keys.reduce((obj, key) => obj[key], state);
		keys.push(val ? 0 : 1);
		this.nestedUpdate(state, ...keys);
	};

	// ============= AJAX FUNCTIONS =====================

	componentDidMount = async () => {
		this.getWarehouses();
	};

	getWarehouses = async () => {
		let ajaxURL = this.props.APIUrl + "/emco_settings/get-warehouses";
		let data = {
			trendId: localStorage.getItem("trendId"),
			token: localStorage.getItem("token"),
			project_id: this.props.projectId
		};
		let APIResponse = await Axios.post(ajaxURL, data);

		if (APIResponse.data.hasOwnProperty("error")) {
			this.nestedUpdate(this.state, "response", APIResponse.data);
			return;
		}
		this.setState(state => ({
			response: {},
			allWarehouses: APIResponse.data
		}));
	};

	getSettings = async e => {
		let warehouse = e.target.previousSibling.value;

		let newState = this.resetState();
		newState.allWarehouses = this.state.allWarehouses;
		newState.warehouse = warehouse;
		this.nestedUpdate(newState, "roomsLoaded", 0);

		let ajaxURL = this.props.APIUrl + "/emco_settings/get-warehouse-room-titles";
		let data = {
			trendId: localStorage.getItem("trendId"),
			token: localStorage.getItem("token"),
			warehouse: warehouse
		};
		let APIResponse = await Axios.post(ajaxURL, data);
		if (APIResponse.data.hasOwnProperty("error")) {
			this.nestedUpdate(newState, "response", APIResponse.data);
			return;
		}

		newState.roomTitles = APIResponse.data.roomTitles;
		this.nestedUpdate(newState, "roomsLoaded", 1);
	};

	submit = async () => {
		let state = this.state;
		let ajaxURL = this.props.APIUrl + "/emco_settings/save-warehouse-room-title";

		let data = {
			trendId: localStorage.getItem("trendId"),
			token: localStorage.getItem("token"),
			warehouse: state.warehouse,
			newRoomTitle: state.newRoomTitle,
		};

		this.nestedUpdate(state, "response", { loadingbar: translator("Misc", "loading_label") });

		let APIResponse = await Axios.post(ajaxURL, data);
		console.log(APIResponse.data);

		if (APIResponse.data.hasOwnProperty("error")) {
			this.nestedUpdate(this.state, "response", APIResponse.data);
			return;
		}

		let newURL = this.props.APIUrl + "/emco_settings/get-warehouse-room-titles";
		let newData = {
			trendId: localStorage.getItem("trendId"),
			token: localStorage.getItem("token"),
			warehouse: state.warehouse
		};

		let newResponse = await Axios.post(newURL, newData);

		this.setState(state => ({
			response: {},
			roomTitles: newResponse.data.roomTitles,
			newRoomTitle: "",
		}));
	};

	deleteRoom = async (roomToRemove) => {
		let state = this.state;
		let ajaxURL = this.props.APIUrl + "/emco_settings/delete-warehouse-room-title";

		let data = {
			trendId: localStorage.getItem("trendId"),
			token: localStorage.getItem("token"),
			roomToRemove: roomToRemove.id,
		};

		this.nestedUpdate(state, "response", { loadingbar: translator("Misc", "loading_label") });

		let APIResponse = await Axios.post(ajaxURL, data);

		if (APIResponse.data.hasOwnProperty("error")) {
			this.nestedUpdate(this.state, "response", APIResponse.data);
			return;
		}

		let newURL = this.props.APIUrl + "/emco_settings/get-warehouse-room-titles";
		let newData = {
			trendId: localStorage.getItem("trendId"),
			token: localStorage.getItem("token"),
			warehouse: state.warehouse
		};

		let newResponse = await Axios.post(newURL, newData);

		this.setState(state => ({
			response: {},
			roomTitles: newResponse.data.roomTitles,
			newRoomTitle: "",
		}));
	};

	updateRoomTitle = async(e, index) => {
		let roomTitles = this.state.roomTitles;
		let roomToUpdate = roomTitles[index];
		roomToUpdate.title = e.target.value;
		roomTitles[index] = roomToUpdate;
		this.setState({ roomTitles });
	};

	saveUpdatedRoomTitle = async(e, index) => {
		let state = this.state;
		let ajaxURL = this.props.APIUrl + "/emco_settings/update-warehouse-room-title";

		let data = {
			trendId: localStorage.getItem("trendId"),
			token: localStorage.getItem("token"),
			id: state.roomTitles[index].id,
			newRoomTitle: state.roomTitles[index].title,
		};

		this.nestedUpdate(state, "response", { loadingbar: translator("Misc", "loading_label") });

		let APIResponse = await Axios.post(ajaxURL, data);

		if (APIResponse.data.hasOwnProperty("error")) {
			this.nestedUpdate(this.state, "response", APIResponse.data);
			return;
		}

		let newURL = this.props.APIUrl + "/emco_settings/get-warehouse-room-titles";
		let newData = {
			trendId: localStorage.getItem("trendId"),
			token: localStorage.getItem("token"),
			warehouse: state.warehouse
		};

		let newResponse = await Axios.post(newURL, newData);

		this.setState(state => ({
			response: {},
			roomTitles: newResponse.data.roomTitles,
			newRoomTitle: "",
		}));
	};

	// ============= RENDER FUNCTIONS =====================

	responseCard = response => {
		if (Object.keys(response).length === 0) return null;
		let key = "error";
		if (response.hasOwnProperty("success")) key = "success";
		if (response.hasOwnProperty("loadingbar")) key = "loadingbar";
		let cardClass = "card user-profile-card response-" + key;
		return (
			<div className={cardClass}>
				<div class="card-body">{response[key]}</div>
			</div>
		);
	};

	renderRooms = state => {
		return (
			<div class="card user-profile-card room-title-listing">
				<div class="card-body">
					<h2>{translator("Admin Room Title Settings", "title")}</h2>
					{state.roomTitles.map((roomTitle, index) => (
						<div key={index}>
							<input
								type="text"
								class="form-control room-title"
								value={roomTitle.title}
								onChange={e =>
									this.updateRoomTitle(
										e,
										index
									)
								}
								onBlur={e =>
									this.saveUpdatedRoomTitle(
										e,
										index
									)
								}
							/>
							<Button
								color="primary"
								onClick={() =>
									this.deleteRoom(roomTitle)
								}
							>
								<i
									class="fa fa-window-close fa-2x"
									aria-hidden="true"
								/>
							</Button>
						</div>
					))}

					<div>
						<input 
							type="text" 
							className="form-control room-title" 
							id="room-title" 
							placeholder={translator(
								"Project Setup",
								"name_section_label"
							)}
							value={state.newRoomTitle}
							onChange={event =>
								this.setState({
									newRoomTitle: event.target.value
								})
							}/>
						<button 
							type="button" 
							class="btn btn-primary new-room-title-submit" 
							onClick={this.submit}>
							{translator("Admin Picturebook", "submit_btn")}
						</button>
					</div>
				</div>
			</div>
		);
	};

	render() {
		let state = this.state;

		let main = (
			<>
				<div class="card user-profile-card">
					<div class="card-body">
						<form class="pb-warehouse-select">
							<select class="dropdown-toggle form-control" type="button" id="dropdownMenuButton">
								<option>{translator("Admin Picturebook", "select_warehouse")}</option>
								{state.allWarehouses.map(warehouse => {
									return (
										<option key={warehouse.warehouse} value={warehouse.warehouse}>
											{warehouse.warehouse}
										</option>
									);
								})}
							</select>
							<button type="button" class="btn btn-primary" onClick={this.getSettings}>
								{translator("Misc", "select_label")}
							</button>
						</form>
					</div>
				</div>

				{state.roomsLoaded ? this.renderRooms(state) : null}

				{this.responseCard(state.response)}
			</>
		);

		return (
			<SettingsWrapper header={translator("Admin Room Title Settings", "page_heading")} main={main} />
		);
	}
}

const mapStateToProps = state => ({
	APIUrl: state.APIUrl
});

const mapDispatchToProps = {};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(RoomTitleSettings);
